import { render, staticRenderFns } from "./RulerSetting.vue?vue&type=template&id=3b8e8ce0&scoped=true"
import script from "./RulerSetting.vue?vue&type=script&lang=js"
export * from "./RulerSetting.vue?vue&type=script&lang=js"
import style0 from "./RulerSetting.vue?vue&type=style&index=0&id=3b8e8ce0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8e8ce0",
  null
  
)

export default component.exports